import { useState } from "react";

/** Before/after comparison slider — source fills the left, the generated result is revealed on the
 * right; drag the divider to compare. Source/result sides match the corner labels. */
export function BeforeAfter({ before, after }: { before: string; after: string }) {
  const [pos, setPos] = useState(50);
  return (
    <div className="ba">
      <img src={before} alt="source" className="ba-img" />
      {/* Result overlays the source, clipped from the LEFT so it occupies the right of the divider. */}
      <img src={after} alt="result" className="ba-img ba-after" style={{ clipPath: `inset(0 0 0 ${pos}%)` }} />
      <span className="ba-label left">source</span>
      <span className="ba-label right">result</span>
      <div className="ba-divider" style={{ left: `${pos}%` }} />
      <input
        className="ba-range"
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="compare source and result"
      />
    </div>
  );
}
